exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.qr-wrap[data-v-55e18e1a] {\n  text-align: center;\n  padding: 8px 0 4px;\n}\n.qr-table[data-v-55e18e1a] {\n  font-size: 18px;\n  font-weight: 600;\n  color: #222;\n}\n.qr-img[data-v-55e18e1a] {\n  width: 240px;\n  height: 240px;\n  margin-top: 12px;\n}\n.qr-store[data-v-55e18e1a] {\n  font-size: 13px;\n  color: #999;\n  margin-top: 8px;\n}\n.qr-type-tip[data-v-55e18e1a] {\n  font-size: 12px;\n  color: #1890ff;\n  margin-top: 4px;\n}\n.qr-btns[data-v-55e18e1a] {\n  margin-top: 16px;\n}\n.qr-format[data-v-55e18e1a] {\n  text-align: center;\n  margin-top: 12px;\n}\n", ""]);

// exports
